import { useClerk } from '@clerk/nextjs';
import { V2 } from '@firmable/common';
import { Logo } from '@firmable/icons';
import { Trans, useTranslation } from '@firmable/i18n';
import { Routes } from '@web/constants/routes';
import Link from 'next/link';
import React from 'react';

export const AccessRemoved = () => {
  const { t } = useTranslation('common');
  const { signOut } = useClerk();
  const [signingOut, setSigningOut] = React.useState(false);

  const handleSignOut = () => {
    setSigningOut(true);
    signOut({ redirectUrl: Routes.signInPath });
  };

  return (
    <div className="bg-neutral-50 flex flex-col gap-6 items-center w-[400px] sm:w-[440px] px-6 sm:px-10 py-8 rounded-2xl">
      <Logo.Light.FirmableFull height={30} width={142} />

      <div className="flex flex-col gap-2 items-center text-center w-full">
        <h1 className="font-semibold text-[30px] leading-[40px] text-neutral-800">{t('accessRemoved.title')}</h1>
        <p className="text-sm text-neutral-500">
          <Trans
            t={t}
            i18nKey="accessRemoved.body"
            components={{
              supportLink: (
                <Link
                  href={Routes.contactSales}
                  target="_blank"
                  className="text-content-interactive underline underline-offset-2"
                />
              ),
            }}
          />
        </p>
      </div>

      <V2.Button
        variant="primary"
        size="lg"
        disabled={signingOut}
        onClick={handleSignOut}
        className="!w-full !h-11 !bg-brand-1-600 hover:!bg-brand-1-700 !text-white !font-semibold !text-base !rounded-lg shadow-btn-bevel">
        {signingOut ? t('accessRemoved.signingOut') : t('accessRemoved.signOut')}
      </V2.Button>
    </div>
  );
};
